"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageStore = void 0;
class LocalStorageStore {
  constructor(storageKey) {
    this.key = storageKey;
  }
  get() {
    const str = localStorage.getItem(this.key);
    if (!str) {
      return null;
    }
    let data;
    try {
      data = JSON.parse(str);
    } catch (e) {
      return null;
    }
    const {
      expires,
      value
    } = data;
    if (new Date().getTime() > expires) {
      return null;
    }
    return value;
  }
  set(value, expires) {
    const data = {
      expires: expires === null || expires === void 0 ? void 0 : expires.getTime(),
      value
    };
    localStorage.setItem(this.key, JSON.stringify(data));
  }
  delete() {
    return localStorage.removeItem(this.key);
  }
}
exports.LocalStorageStore = LocalStorageStore;